import React from "react";
import {Controller, useForm} from "react-hook-form";
import NiceModal, {NiceModalHocProps, useModal} from "@ebay/nice-modal-react";
import {Dialog} from "../../../../ui";
import {TextField} from "../../../bounce-ui";
import {FormValidations} from "../../../helpers";
import {EMAIL_REGEX} from "../../../../constants";

interface IEditContactDialog extends NiceModalHocProps {
  type: "tel" | "email";
  value: string;
  isLoading: boolean;
  onValueUpdated?: (value: string) => void;
}

type FormValues = {
  value: string;
};

const EditContactDialog = NiceModal.create(({value, type, onValueUpdated}: IEditContactDialog) => {
  const modal = useModal();

  const {control, handleSubmit, watch} = useForm<FormValues>();
  const currValue = watch("value");

  const onSubmit = handleSubmit((data): void => {
    onValueUpdated?.(data.value);

    modal.resolve(true);
    modal.hide();
  });

  return (
    <Dialog
      title={"Update contact info"}
      buttonText={"Update"}
      onClick={onSubmit}
      disabled={!currValue || currValue === value}
      autoClose={false}
      width={"280px"}
      padding={"24px"}
    >
      <form onSubmit={onSubmit} style={{width: "100%"}}>
        <Controller
          name="value"
          rules={{
            required: "Required field",
            validate: (value) =>
              type === "tel" && FormValidations.validateTelephone(value) ? "Invalid phone" : undefined,
            ...(type === "email" && {
              pattern: {value: EMAIL_REGEX, message: "Invalid email"},
            }),
          }}
          control={control}
          defaultValue={value}
          render={({field: {ref, ...field}, fieldState: {invalid, error}}) => {
            return (
              <TextField
                {...field}
                inputRef={ref}
                fullWidth
                label={type === "tel" ? "Phone number" : "Email"}
                autoComplete="off"
                autoFocus
                error={invalid}
                helperText={error?.message}
              />
            );
          }}
        />
      </form>
    </Dialog>
  );
});

export default EditContactDialog;
